export enum API_PLATFORM_TOKEN_STORAGE_KEYS {
  AUTH_TOKEN_KEY = 'dPvT2Pi8EB',
  REFRESH_TOKEN_KEY = '1631d44a-7c93-497a-b8a4-c63f36bea592',
}

export enum API_PLATFORM_TOKEN_SALTS {
  AUTH_TOKEN_SALT = '911762fa-90b8-45dd-8ead-cf7d22787bc3',
  REFRESH_TOKEN_SALT = '6ecf6d9e-8d6e-4431-a6d3-6d9a5f55f563',
}
